import request from '../../utils/request';

export const functionService = {
    //列表数据查询
    getFunctionData: (data) => {
        return request({
            url: '/function/list',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    saveOrUpdateFunction: (data) => {
        return request({
            url: '/function/save',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    deleteFunction: (data) => {
        return request({
            url: '/function',
            method: 'delete',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
}